function About() {
  return (
    <div className="pagecontent textpage">
	  <p className="reveal"><b>Registered name:</b> Blue Coast Capital Properties Limited<br />
<b>Company registration number:</b> 00796229<br />
Registered in England and Wales<br />
<b>Registered office address:</b><br />Seymour Mews House,<br />26-37 Seymour Mews,<br />London,<br />W1H 6BN</p>
 
<p className="reveal"><b>Registered name:</b> L51N Limited<br />
<b>Company registration number:</b> 06791528<br />
Registered in England and Wales<br />
<b>Registered office address:</b><br />Seymour Mews House,<br />26-37 Seymour Mews,<br />London,<br />W1H 6BN</p>
    </div>
  );
}

export default About;
